<template>
  <div>
    <van-button type="primary" @click="aliPay">支付宝</van-button>
    <van-button type="primary" @click="wxPay">微信</van-button>
  </div>
</template>
<script>
import { deviceType } from "../../util/deviceType";
import wx from "weixin-jsapi";
import http from "../../util/demoApiConfig";
import http2 from "../../util/gaeaApiConfig";
export default {
  data() {
    return {
      user_id: 1,
      order_id: 2,
      openid: false,
      token: "",
      appid: "wxcc7ab5ca954203d8",
      is_weixin: deviceType.isWeiXin,
      is_app: deviceType.isApp,
    };
  },

  created() {
    var user_info = this.$appUtils.appData();
    if (user_info) {
      this.user_id = user_info.user_id;
      this.token = user_info.token;
    }
    if (localStorage.getItem("user_id")) {
      this.user_id = localStorage.getItem("user_id");
    }
    if (localStorage.getItem("openid")) {
      this.openid = localStorage.getItem("openid");
    }
    if (this.is_weixin && !this.openid) {
      let code = this.$route.query.code;
      if (code) {
        this.getOpenid(code);
      } else {
        let redirectUrl = window.location.href;
        redirectUrl = encodeURIComponent(redirectUrl);
        let url =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          this.appid +
          "&redirect_uri=" +
          redirectUrl +
          "&response_type=code&scope=snsapi_userinfo&state=type%wechat_redirect";
        window.location.href = url;
      }
    }
  },
  methods: {
    getOpenid(code) {
      let that = this;
      let params = { code: code };
      http2.get("/users/oauth/user", { params: params }).then(function (res) {
        if (res.data.status_code == 200) {
          that.openid = res.data.data.openid;
          localStorage.getItem("openid", that.openid);
        }
      });
    },
    toPay(params, scene) {
      let that = this;
      http
        .get("users/" + that.user_id + "/order", {
          params: params,
          headers: { Authorization: that.token },
        })
        .then(function (res) {
          if (res.data.status_code == 200) {
            if (params["pay_type"] == "ali_wap") {
              //window.location.href = res.data.data;
            } else if (params["pay_type"] == "wx_h5_wap") {
              //window.location.href = res.data.data.mweb_url + '&redirect_url=' + params['return_url'];
            } else if (params["pay_type"] == "wx_js") {
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener(
                    "WeixinJSBridgeReady",
                    that.onBridgeReady(res.data.data),
                    false
                  );
                } else if (document.attachEvent) {
                  document.attachEvent(
                    "WeixinJSBridgeReady",
                    that.onBridgeReady(res.data.data)
                  );
                  document.attachEvent(
                    "onWeixinJSBridgeReady",
                    that.onBridgeReady(res.data.data)
                  );
                }
              } else {
                that.onBridgeReady(res.data.data);
              }
            }
          } else if (res.data.status_code == 4000) {
            localStorage.removeItem("openid");
            this.$router.go(0);
          }
        });
    },
    aliPay() {
      //scene 1:支付宝支付
      let that = this;
      let params = {
        order_type: "prescription",
        prescription_id: 1,
        return_url:
          window.location.origin + "/orderresult?order_id=" + that.order_id,
      };
      if (that.is_app) {
        params["scene"] = 1;
        that.$appUtils.appPay(params);
      } else {
        params["pay_type"] = "ali_wap";
        params["order_type"] = "ali_wap";
        that.toPay(params);
      }
    },
    wxPay() {
      //scene 0:微信支付
      let that = this;
      let params = {
        order_type: "prescription",
        prescription_id: 1,
        return_url:
          window.location.origin + "/orderresult?order_id=" + that.order_id,
      };
      if (that.is_app) {
        params["scene"] = 0;
        that.$appUtils.appPay(params);
      } else {
        if (that.is_weixin) {
          params["pay_type"] = "wx_js";
          params["order_type"] = "wx_js";
          params["openid"] = that.openid;
        } else {
          params["pay_type"] = "wx_h5_wap";
          params["order_type"] = "wx_h5_wap";
        }
        that.toPay(params);
      }
    },
    onBridgeReady(data) {
      let that = this;
      window.WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: data.appId, // 公众号名称，由商户传入
          timeStamp: data.timeStamp, // 时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, // 随机串
          package: data.package,
          signType: data.signType, // 微信签名方式：
          paySign: data.paySign, // 微信签名
        },
        function (res) {
          // alert(JSON.stringify(res))
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            localStorage.setItem("out_trade_no", data.out_trade_no);
            //window.location.href = window.location.origin + "/orderresult?order_id="+that.order_id;
          }
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/order/demo.vue